import styled from "styled-components";

const FooterWrapper = styled.footer<{ active: boolean }>`
  font-size: 0.9rem;
  width: 100%;
  border-top: 1px solid #f4f4f4;
  position: fixed;
  bottom: 0;
  left: ${props => (props.active ? "300px" : "60px")};
  background-color: #fff;
  z-index: 3;
  padding: 10px 20px;
  white-space: nowrap;

  span {
    color: #7c8484;
    em {
      color: #7c8484;
      margin-right: 6px;
    }
  }
`;

/**
 * Fixed footer
 * @returns JSX.Element
 */
function Footer(props: { active: boolean }): JSX.Element {
  return (
    <FooterWrapper active={props.active}>
      <div>
        <span>
          <em>Copyright</em>
        </span>
        <span>2023. FASTVIEW inc. all rights reserved.</span>
      </div>
    </FooterWrapper>
  );
}

export default Footer;
